<img
  #img
  [src]="src || 'https://placehold.co/600x400?text=MISSING+IMAGE'"
  (mouseover)="onMouseOver($event)"
  (mouseleave)="onMouseLeave()"
  (mousemove)="onMouseMove($event)"
  alt="Loading image"
  [style.filter]="sanitizeStyle('brightness(' + brightness + '%) contrast(' + contrast + '%)')"
  (click)="imageClicked($event)"
  (load)="updateMarkerPosition()"
  />

  @if (position && position.percentX !== 0 && position.percentY !== 0 && !zooming) {
    <div
      class="position-marker"
      [style.left.%]="markerLeft"
      [style.top.%]="markerTop"
    ></div>
  }
  @if (showLoader$ | async) {
    <div class="loader">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  }
